<template>
    <BlogList
        :breadcrumb-title="data?.collection?.name"
        :categories="data?.postCategories"
        :posts="data?.collection?.posts"
        :total-posts="data?.collection?.postAggregation.count"
        :description="description"
        :meta-title="title"
        :error="error"
        :fetching="fetching"
        :has-data="!!data"
        :page="page"
        :response-errors="responseErrors"
        :stale="stale"
        :title="title"
        @try-again="executeQuery"
    />
</template>

<script lang="ts" setup>
import { computed, provide } from 'vue'
import { type PostsByCategoryQueryVariables } from '@/graphql/api'
import { useTranslator } from '@/i18n'
import { useResponseError } from '@/helpers/errors'

import BlogList from '@/components/cms/component/blog/BlogList.vue'
import { usePostsByCategoryQuery } from './BlogCategory.generated.ts'
import { useBlogFeedLink } from '@/views/blog/composables/useBlogFeedLink.ts'

const props = defineProps<{
    slug: string
    page: number
}>()

useBlogFeedLink()

const { locale } = useTranslator()

const variables = computed((): PostsByCategoryQueryVariables => {
    return {
        slug: props.slug,
        page: props.page,
        limit: 10,
        locale: locale.value,
    }
})

const response = usePostsByCategoryQuery({ variables })
provide('response', response)
await response

const responseErrors = useResponseError(response)

const { fetching, data, error, stale, executeQuery } = response

// TODO translate
const title = computed(
    () => `Posts in "${data.value?.collection?.name || 'category'}"`
)
// TODO translate
const description =
    'Find out all you need to know about engagement rings - from diamond and gemstone guidance to trends and proposal inspiration.'
</script>
